export const GET_AUTHORIZED_ROUTES = 'GET_AUTHORIZED_ROUTES'